import { useTranslations } from 'next-intl';
import {
    GlowClickable,
    GlowIcon,
    GlowTextBody,
    GlowTitle,
    Icons,
    PropsWithFontFamily,
} from '@headless-workspace/glow-ds';
import { InnerHTML } from '../../innerHTML';
import { usePriceRegulationAssets } from '../../productDetails/infos/hooks/usePriceRegulationAssets';

type PriceRegulationModalProps = {
    close(id: string, remove?: boolean): void;
    id: string;
} & PropsWithFontFamily;

export function PriceRegulationModal(props: PriceRegulationModalProps) {
    const { result } = usePriceRegulationAssets();
    const t = useTranslations('Discover.Pdp.information.price');
    const { close, fontFamily, id } = props;
    return (
        <div
            id={'product-detail-regulation-info-modal'}
            className={'h-fullViewport w-fullViewport tablet:w-sideMenuTablet flex flex-col bg-background-l3'}
        >
            <div
                className={
                    'flex flex-row justify-start items-center p-1 gap-1 border-b-medium border-b-border-subtle border-solid h-headerFixedNavDesktop'
                }
            >
                <GlowClickable
                    onClick={() => close(id)}
                    content={{
                        icon: <GlowIcon Icon={Icons.ArrowLeft} type={'large'} className={'text-text-primary'} />,
                    }}
                />

                <GlowTitle
                    text={t('pricesModal.label.secondTitle')}
                    fontSize={'title4'}
                    fontFamily={fontFamily}
                    className={'flex-1 text-left'}
                />
            </div>
            <div className={'p-[1rem] flex flex-col gap-[1rem]'}>
                <span className={'text-text-primary text-[1.125rem] font-bold'}>
                    {t('legalMentionsModal.label.subTitle')}
                </span>
                <GlowTextBody
                    fontFamily={fontFamily}
                    innerHTML={
                        <InnerHTML
                            rawHtml={{
                                content: String(result),
                            }}
                        />
                    }
                />
            </div>
        </div>
    );
}
